import { render, staticRenderFns } from "./ContinueRegistration.vue?vue&type=template&id=45fbab0b"
import script from "./ContinueRegistration.vue?vue&type=script&lang=js"
export * from "./ContinueRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports